import { FileObjectType } from "@jsq/ds/core";
import { BaseDocumentType, DocumentStatus } from "../../../graphql/supergraphEnums";
import { type RequestedDocumentType } from "../../../graphql/supergraphTypes";
import { type DocumentData } from "../DocumentCollector/types";
import { type DocumentDetailsType } from "../DocumentLists/types";
import { getDocumentCategoryInfo } from "../DocumentLists/utils";

export type DocumentsMap = Record<string, DocumentDetailsType>;

export const getDocumentKey = (baseType: string, subType: string | null): string =>
  `${baseType}_${subType}`;

export const prepareDocumentsForUpload = (documents: DocumentsMap): DocumentData[] =>
  Object.values(documents)
    .filter((doc): doc is DocumentDetailsType & { file: FileObjectType } => doc.file !== null)
    .map((doc) => ({
      baseType: doc.baseType as BaseDocumentType,
      subType: doc.subType,
      file: doc.file,
    }));

export const mapGuestDocumentsToFormProps = (
  documentTypes: Array<RequestedDocumentType>,
): DocumentDetailsType[] => {
  return (
    documentTypes
      // Filter out documents that are marked as uploaded but don't exist in the documents array
      .filter((docType) => {
        return docType.status !== DocumentStatus.Uploaded;
      })
      .map((docType) => {
        const documentCategory = getDocumentCategoryInfo(docType.baseType, docType.subType);

        return {
          id: undefined,
          baseType: docType.baseType,
          subType: docType.subType || null,
          file: null,
          title: documentCategory.title,
          description: documentCategory.description,
          example: documentCategory.example,
        };
      })
  );
};
